function formatDate(dateString) {
    if (!dateString) return '';

    const options = { month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
}

function formatDateLong(dateString) {
    if (!dateString) return '';

    const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(Number(dateString)).toLocaleDateString(undefined, options);
}

function formatDate3(timestamp) {
    // Convert the timestamp to milliseconds
    const date = new Date(timestamp * 1000);

    // Define an array of month names
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Extract the day, month, year, hours, and minutes
    const day = date.getUTCDate();
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();

    // Format the date and time
    const formattedDate = `${day} ${month} ${year}`;

    return formattedDate;
};


export { formatDate, formatDateLong, formatDate3 };